import Button from "@Components/Button";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import { useCallback, useState } from "react";
import styles from "./description.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import useIsDesktop from "hooks/useIsDesktop";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import ArrowDownIcon from "@Icons/ArrowDownIcon";
import useTranslationHook from "hooks/useTranslationHook";
import replaceAmberDomainInLinks from "@Utils/clientUtils/dangerouslySetInnerHtmlUtility/replaceAmberDomainInLinks";
//

const Description = ({ content }: { content: any }) => {
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [isDescriptionOverflow, setIsDescriptionOverflow] = useState(false);
  const isDesktop = useIsDesktop();
  const { t } = useTranslationHook();

  const ref = useCallback(
    (node: HTMLDivElement) => {
      const REQUIRED_NODE_HEIGHT = isDesktop ? 42 : 72;
      if (node !== null) {
        setIsDescriptionOverflow(node.scrollHeight > REQUIRED_NODE_HEIGHT);
      }
    },
    [isDesktop],
  );

  return (
    <div className={!isDesktop && styles.container}>
      {Boolean(content?.value) && (
        <div
          ref={ref}
          className={formatClassNames(
            styles.description,
            isDescriptionOverflow &&
              (showFullDescription ? styles.fullDescription : styles.shortDescription),
          )}
          dangerouslySetInnerHTML={{ __html: replaceAmberDomainInLinks(content?.value) }}
        />
      )}
      {isDescriptionOverflow && (
        <Button
          type="button"
          onClick={() => {
            setShowFullDescription((prev) => !prev);
            gtagEventEmitter({
              action: showFullDescription
                ? "room-details-description-collapsed"
                : "room-details-description-expanded",
              category: "room-type",
              label: "view_more_details",
            });
          }}
          variant="subtle"
          className={formatClassNames(styles.toggleTextButton, showFullDescription && styles.less)}
          dataTestId="property-room-type-view-more-detials-read-more"
          RightIcon={ArrowDownIcon}
        >
          {showFullDescription
            ? t("propertypage.roomtypesectiondynamic.roomtypecard.readless")
            : t("propertypage.roomtypesectiondynamic.roomtypecard.readmore")}
        </Button>
      )}
    </div>
  );
};

export default wrapperHOC(Description, {
  componentName: "Description-ViewMoreDetailsModal-RoomTypeCard-PropertyPage",
  showForChina: true,
});
